import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axiosInterceptor";

const GATEWAY_BASE = process.env.REACT_APP_API_GATEWAY_BASE;
const AUTH_BASE = process.env.REACT_APP_AUTH_BASE || "";

export const postAddSecondaryEmail = createAsyncThunk(
  "postAddSecondaryEmail",
  async (email: string) => {
    const { data } = await axios.post(
      `${GATEWAY_BASE + AUTH_BASE}/v1/addSecondaryEmail`,
      { email }
    );
    return data;
  }
);

const postAddSecondaryEmailSlice = createSlice({
  name: "postAddSecondaryEmail",
  initialState: {
    loading: false,
    addSecondaryEmail: null as any,
    error: false,
    success: false,
  },
  reducers: {
    resetAddSecondary: (state) => {
      state.loading = false;
      state.addSecondaryEmail = null;
      state.error = false;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postAddSecondaryEmail.pending, (state, action) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(postAddSecondaryEmail.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.error = false;
      state.addSecondaryEmail = action.payload;
    });
    builder.addCase(postAddSecondaryEmail.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
    });
  },
});

export const { resetAddSecondary } = postAddSecondaryEmailSlice.actions;

export default postAddSecondaryEmailSlice.reducer;
